import {
  ApiCommand,
  ApiRequest,
  ApiResponse,
  ListingRequestSource, ListingResponse,
} from '@/store/modules/api';
import { formatListingRequest } from '@/pages/documents/lib/format-listing-request';
import { ApiResponseError } from '@/service/api';
import {
  IncomingDocument,
  IncomingDocumentGroup,
  IncomingDocumentType,
} from '@/pages/documents/@x/incoming-document-group';
import { asyncStore } from '@/store';

export type GetIncomingGroupDocumentsParams = {
  company?: string;
  type?: IncomingDocumentType;
};

export const getIncomingGroupDocuments = async (
  model: ListingRequestSource<GetIncomingGroupDocumentsParams>,
): Promise<ApiResponse<ListingResponse<IncomingDocumentGroup>>> => {
  try {
    let api = (() => {}) as any;

    await asyncStore.then((store) => {
      api = <T = any>(request: ApiRequest) => store.dispatch(
        'api/request',
        request,
        { root: true },
      ) as Promise<ApiResponse<T>>;
    });

    const result = await api({
      command: ApiCommand.getIncomingGroupDocuments,
      params: formatListingRequest(model),
      signal: model.signal,
    });

    return result;
  } catch (_) {
    return { status: false } as ApiResponseError;
  }
};

export const postIncomingGroupDocuments = async (
  model: {
    documents?: IncomingDocument[];
    type: IncomingDocumentType;
    company: number;
  },
): Promise<ApiResponse<IncomingDocumentGroup>> => {
  try {
    let api = (() => {}) as any;

    await asyncStore.then((store) => {
      api = <T = any>(request: ApiRequest) => store.dispatch(
        'api/request',
        request,
        { root: true },
      ) as Promise<ApiResponse<T>>;
    });

    const result = await api({
      command: ApiCommand.postIncomingGroupDocuments,
      data: model,
    });

    return result;
  } catch (_) {
    return { status: false } as ApiResponseError;
  }
};

export const removeIncomingGroupDocument = async (model: ApiRequest<{ id: number }>): Promise<ApiResponse<never> | ApiResponseError> => {
  try {
    let api = (() => {}) as any;

    await asyncStore.then((store) => {
      api = <T = any>(request: ApiRequest) => store.dispatch(
        'api/request',
        request,
        { root: true },
      ) as Promise<ApiResponse<T>>;
    });

    const result = await api({
      command: ApiCommand.removeIncomingGroupDocument,
      params: model.params,
      signal: model.signal,
    });

    return result;
  } catch (_) {
    return { status: false } as ApiResponseError;
  }
};

export const archiveIncomingGroupDocument = async (model: {
  company_id: number;
  group_ids: number[];
}): Promise<ApiResponse<{
  company_id: number;
  group_ids: number[];
  uuid: string;
}> | ApiResponseError> => {
  try {
    let api = (() => {}) as any;

    await asyncStore.then((store) => {
      api = <T = any>(request: ApiRequest) => store.dispatch(
        'api/request',
        request,
        { root: true },
      ) as Promise<ApiResponse<T>>;
    });

    const result = await api({
      command: ApiCommand.archiveIncomingGroupDocument,
      data: model,
    });

    return result;
  } catch (_) {
    return { status: false } as ApiResponseError;
  }
};

export const postIncomingDocument = async (params: {
  model: {
    file: File;
    group: number;
  };
  signal: AbortSignal;
}): Promise<ApiResponse<void>> => {
  try {
    let api = (() => {}) as any;

    await asyncStore.then((store) => {
      api = <T = any>(request: ApiRequest) => store.dispatch(
        'api/request',
        request,
        { root: true },
      ) as Promise<ApiResponse<T>>;
    });

    const result = await api({
      command: ApiCommand.postIncomingDocument,
      data: params.model,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      signal: params.signal,
    });

    return result;
  } catch (_) {
    return { status: false } as ApiResponseError;
  }
};
